// extracted by mini-css-extract-plugin
export var footer = "_oh-5";
export var fulfillmentInput = "_oh-0";
export var shipDateInput = "_oh-1";
export var shipmentModal = "_oh-2";
export var shipmentModalContent = "_oh-3";
export var tableContainer = "_oh-4";